import UserSettingsLayout from "../layouts/UserSettingsLayout";
import UserProfileLayout from "../layouts/UserProfileLayout";

export default ( {
	app,
	authService,
	loadedSlices,
} ) => {
	const lazyLoadUserSettingsComponent = ( { component, } ) => {
		return () => {
			if ( !loadedSlices.has( "@teaming/slice-settings" ) ) {
				return import( "@teaming/slice-settings" ).then( async ( { userSettingsSlice, } ) => {
					userSettingsSlice();
					loadedSlices.set( "@teaming/slice-settings", true );
					return app.component( component );
				} );
			}
			return Promise.resolve( app.component( component ) );
		};
	};

	return [
		{
			path: "/me/settings",
			name: "",
			meta: { title: "slice-settings.routes.default", },
			component: UserSettingsLayout,
			props: true,
			children: [
				{
					path: "",
					name: "User Settings",
					component: lazyLoadUserSettingsComponent( { component: "UserSettingsHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},

		{
			path: "/me/profile",
			name: "",
			meta: { title: "slice-settings.routes.myProfile", },
			component: UserProfileLayout,
			props: true,
			children: [
				{
					path: "",
					name: "User Profile",
					component: lazyLoadUserSettingsComponent( { component: "ProfileHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},
	];
};
